// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsAuthenticationGetCurrentUserGetCurrentUserResponseModel {
    static getAttributeTypeMap() {
        return ScriptsAuthenticationGetCurrentUserGetCurrentUserResponseModel.attributeTypeMap;
    }
}
ScriptsAuthenticationGetCurrentUserGetCurrentUserResponseModel.discriminator = undefined;
ScriptsAuthenticationGetCurrentUserGetCurrentUserResponseModel.additionalProperties = false;
ScriptsAuthenticationGetCurrentUserGetCurrentUserResponseModel.attributeTypeMap = [
    {
        "name": "userId",
        "baseName": "userId",
        "type": "number"
    },
    {
        "name": "userName",
        "baseName": "userName",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "ScriptsAuthenticationGetCurrentUserGetCurrentUserContactInfoResponseModel"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "ScriptsAuthenticationGetCurrentUserGetCurrentUserContactInfoResponseModel"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "ScriptsAuthenticationGetCurrentUserGetCurrentUserContactInfoResponseModel"
    },
    {
        "name": "role",
        "baseName": "role",
        "type": "string"
    },
    {
        "name": "active",
        "baseName": "active",
        "type": "boolean"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
];
//# sourceMappingURL=scriptsAuthenticationGetCurrentUserGetCurrentUserResponseModel.js.map